import style from "../style/worldcupbar.module.css";
export default function WorldCupBar({ round, currendRound }) {
  return (
    <div>
      <h3 className={style.WorldCupBar_title}>{round}</h3>
      <p className={style.WorldCupBar_round}>{currendRound}/31</p>
    </div>
  );
}
